import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, Table, Badge } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, find } from "lodash";
import { setHeading } from "../../../accounts/account.actions";
import { GetReceivingApi, AddReceivingReturnApi } from "./Receiving.action";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import Select from "react-select";
import Swal from "sweetalert";
import moment from "moment";


const ReturnReceving = (props) => {
    const [recevingId, setReceivingId] = useState();
    const [reason, setReason] = useState();
    const [recevingName, setReceivingName] = useState();
    const [selectedReceiving, setSelectedReceiving] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const resetForm = () => {
        setReceivingId(null);
        setReason("");
        setReceivingName("");
        setSelectedReceiving(null);
        setSelectedProducts([]);
        setTotalPrice(0);
        setDate(moment().format("YYYY-MM-DD"));
    };
    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        }).then(() => {
            resetForm();
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };

    function SaveReceivingReturn() {
        const productsToReturn = selectedProducts.filter(product => product.returnQuantity > 0).map(product => ({
            productId: product.productId,
            productName: product.productName,
            returnQuantity: product.returnQuantity,
            productPrice: product.purchasePrice,
            totalPrice: Number(parseFloat(product.returnQuantity * product.purchasePrice).toFixed(2))
        }));

        if (productsToReturn.length === 0) {
            handleDangerVisible("Please select at least one product to return");
            return;
        }

        const returnDataPayload = {
            recevingId: recevingId,
            reason: reason,
            date: date,
            returnData: productsToReturn,
            totalPrice: Number(parseFloat(totalPrice).toFixed(2))
        };

        props.AddReceivingReturnApi(
            returnDataPayload,
            () => handleVisible("Return processed successfully!"),
            handleDangerVisible
        );
    }

    const handleChangeReceiving = (selectedOption) => {
        setReceivingId(selectedOption.value);
        setReceivingName(selectedOption.label);

        // Find the selected receiving object
        const receiving = find(props.ReceivingList, { _id: selectedOption.value });
        setSelectedReceiving(receiving);

        // Initialize product selection state
        if (receiving && receiving.receivingData) {
            const productsWithSelection = receiving.receivingData.map(product => ({
                ...product,
                returnQuantity: 0,
                returnTotal: 0
            }));
            setSelectedProducts(productsWithSelection);
            setTotalPrice(0);
        }
    };

    const receivingList = isEmpty(props.ReceivingList) ? [] : props.ReceivingList.map((x) => {
        let data = {
            value: x._id,
            label: `${x.sequenceNumber} / ${moment(x.receivingDate).format("DD-MM-YYYY") || ''} / ${x.recivingDescription || 'Receiving'}`
        };
        return data;
    });

    const handleQuantityChange = (index, value) => {
        const updatedProducts = [...selectedProducts];
        const maxQuantity = updatedProducts[index].requiredProductQuantity;
        const returnQty = Math.min(Math.max(0, value), maxQuantity);

        updatedProducts[index].returnQuantity = returnQty;
        updatedProducts[index].returnTotal = returnQty * updatedProducts[index].purchasePrice;

        setSelectedProducts(updatedProducts);

        // Update total price
        const newTotal = updatedProducts.reduce((sum, product) => sum + (product.returnTotal || 0), 0);
        setTotalPrice(newTotal);
    };

    useEffect(() => {
        props.setHeading("Receiving Return");
        props.GetReceivingApi()
    }, []);

    return (
        <>
            {props.isFetchingReceiving || props.isAddingReceivingReturn ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Receiving *</b></Form.Label>
                                <Select
                                    placeholder="Select Receiving"
                                    onChange={(e) => { handleChangeReceiving(e); }}
                                    options={receivingList}
                                    value={recevingId ? { value: recevingId, label: recevingName } : null}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Reason *</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Reason"
                                    onChange={(e) => { setReason(e.target.value) }}
                                    value={reason || ''}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Date"
                                    name="Date"
                                    onChange={(e) => { setDate(e.target.value) }}
                                    value={date}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {selectedReceiving && selectedProducts.length > 0 && (
                        <>
                            <Row className="mb-3">
                                <Col>
                                    <h5>
                                        Selected Receving:{" "}
                                        <Badge bg="info">{recevingName}</Badge>
                                    </h5>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Table bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>SR</th>
                                                <th>Product</th>
                                                <th>Price</th>
                                                <th>Receiving Quantity</th>
                                                <th>Return Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedProducts.map((product, index) => (
                                                <tr key={product.productId}>
                                                    <td>{index + 1}</td>
                                                    <td>{product.productName}</td>
                                                    <td>{product.purchasePrice.toFixed(2)}</td>
                                                    <td>
                                                        <Badge
                                                            bg={product.requiredProductQuantity < 0 ? "danger" : "success"}
                                                        >
                                                            {product.requiredProductQuantity}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <Form.Group>
                                                            <Form.Control
                                                                type="number"
                                                                min="0"
                                                                max={product.requiredProductQuantity}
                                                                value={product.returnQuantity}
                                                                onChange={(e) => handleQuantityChange(index, parseInt(e.target.value || 0))}
                                                            />
                                                        </Form.Group>
                                                    </td>
                                                    <td>{product.returnTotal.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="text-end">
                                    <h5>
                                        Total Return Value:{" "}
                                        <Badge bg="primary">{totalPrice.toFixed(2)}</Badge>
                                    </h5>
                                </Col>
                            </Row>
                        </>
                    )}

                    <div className="sendDiv">
                        {isEmpty(recevingId) || isEmpty(reason) ? (
                            <Button disabled>Save</Button>
                        ) : (
                            <Button onClick={SaveReceivingReturn}>Save</Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddReceivingReturnApi: (data, handleVisible, handleDangerVisible) => dispatch(AddReceivingReturnApi(data, handleVisible, handleDangerVisible)),
        GetReceivingApi: () => dispatch(GetReceivingApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    ReceivingList: state.RecivingReducer.ReceivingList,
    isFetchingReceiving: state.RecivingReducer.isFetchingReceiving,
    isAddingReceivingReturn: state.RecivingReducer.isAddingReceivingReturn,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnReceving);